import type { ReactNode } from 'react';

import Tooltip from '@cartwhl/ui/atoms/Tooltip';
import CrossIcon from '@cartwhl/ui/icons/CrossIcon';

interface AdditionalDiagramCardFrameProps {
  displayLabel: string;
  removableChainNames: readonly string[];
  onChainClear?: (chainNames: readonly string[]) => void;
  children: ReactNode;
}

export default function AdditionalDiagramCardFrame({
  displayLabel,
  removableChainNames,
  onChainClear,
  children,
}: AdditionalDiagramCardFrameProps) {
  const showClear = Boolean(onChainClear && removableChainNames.length > 0);

  return (
    <div className="group relative">
      {children}
      {showClear && (
        <Tooltip
          text={`Remove ${displayLabel}`}
          side="top"
          inModal
        >
          <button
            type="button"
            onPointerDown={(event) => event.stopPropagation()}
            onClick={(event) => {
              event.stopPropagation();
              onChainClear?.(removableChainNames);
            }}
            aria-label={`Remove ${displayLabel} chain`}
            className="text-secondary hover:text-primary group-hover:pointer-events-auto group-focus-within:pointer-events-auto group-hover:opacity-100 group-focus-within:opacity-100 absolute right-2 top-2 z-10 inline-flex h-6 w-6 items-center justify-center rounded-full bg-white/90 opacity-0 shadow-sm pointer-events-none transition-[color,opacity] dark:bg-gray-90/90"
          >
            <CrossIcon className="h-3 w-3" />
          </button>
        </Tooltip>
      )}
    </div>
  );
}
